<template>
  <div>
    <!-- <v-tabs
      v-bind="$attrs"
      v-on="$listeners"
      v-model="selectedTab"
      hide-slider
      style="border-radius: 15px"
      active-class="active__class ma-0 px-0"
      class="ma-0 px-0"
      :show-arrows="$vuetify.breakpoint.xsOnly"
    >
      <v-tab
        v-for="(item, i) in items"
        :key="i"
        active-class="tab_active__class ma-0 px-0"
        class="ma-0 px-0"
        :disabled="disabled"
      >
        {{ item.text }}
      </v-tab>
    </v-tabs>
    <br /><br /> -->

    <div class="timefilter_div">
      <v-btn
        text
        v-for="(item, i) in items"
        :key="i"
        :disabled="disabled"
        :class="i === selectedTab ? 'tab_active__class' : 'tab'"
        @click="selectedTab = i"
      >
        {{ item.text }}
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: "DateFilterTab",
  props: {
    items: {
      type: Array,
      required: true,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      selectedTab: 0,
    };
  },
  computed: {},
  watch: {
    selectedTab() {
      this.$emit("input", this.selectedTab);
    },
  },
  methods: {},
  mounted() {},
};
</script>
<style scoped>
.active__class {
  background: #e9f1fa !important;
  border-radius: 15px;
}
.tab_active__class {
  background: #e9f1fa !important;
  border-radius: 20px !important;
  color: #2d8cff;
  font-weight: 900;
}
.timefilter_div {
  display: flex;
}
.tab {
  border-radius: 20px !important;
  color: #03314bb2 !important;
}
@media all and (max-width: 600px) {
  .tab_active__class {
    min-width: 0px !important;
  }
  .tab {
    min-width: 0px !important;
  }
}
</style>
